import { AutocompleteField } from "@models/autocompleteField";
import { DataFields } from "@utils/DataField";

export class PersonalDataFields extends DataFields {
    name: string;
    firstName: string;
    email: string;
    phone: string;
    country: AutocompleteField;
    city: AutocompleteField;
    isWorkPermit: boolean | string;
    password?: string;
    oldPassword?: string;
    private _localisations: { isInFrance: boolean, isInEU: boolean };

    get currentLocality(): { isInFrance: boolean, isInEU: boolean } {
        return this._localisations;
    }
    set currentLocality(localisations: { isInFrance: boolean, isInEU: boolean }) {
        this._localisations = localisations;
    }

    errorMessage = "Oups, le formulaire est incomplet.";

    _errorDataFieldMap = new Map<string, string>([
        ["name", "Merci de compléter votre nom."],
        ["firstName", "Merci de compléter votre prénom."],
        ["email", "Merci de compléter votre email."],
        ["phone", "Merci de compléter votre téléphone."],
        ["country", "Merci de compléter votre pays de résidence."],
        ["city", "Merci d'indiquer votre ville de résidence."],
        ["isWorkPermit", "Merci d'indiquer si oui ou non, vous avez un permis de travail."]
    ]);

    toJson() {
        return {
            "name" : this.name,
            "firstName": this.firstName,
            "email": this.email,
            "phone": this.phone,
            "country": this.country,
            "city": this.city,
            "isWorkPermit": this.convertRadioToBoolean(this.isWorkPermit),
            "password": this.password,
            "oldPassword": this.oldPassword
        }
    }
    toArray() {
        return [
            this._toValidity("name", this.name !== ""),
            this._toValidity("firstName", this.firstName !== ""),
            this._toValidity("email", this.email !== ""),
            this._toValidity("phone", this.phone !== "", false),
            this._toValidity("country", this.country && this.country.isValid()),
            this._toValidity("city", this.city && this.city.isValid(), this._localisations?.isInFrance),
            this._toValidity("isWorkPermit", this.isWorkPermit != null, !(this._localisations?.isInEU)),
            this._toValidity("password", this.password !== "", false),
            this._toValidity("oldPassword", this.oldPassword !== "", false)
        ]
    }

    convertRadioToBoolean(value: string | boolean): boolean {
        return (typeof value === "string" && value === "yes"); 
    }
}